import { formatSource, ValidSource } from "@validator/schema";

import { ActivityIcon, Globe } from "lucide-react";

export function ReportHeader({ source }: { source: ValidSource }) {
  return (
    <h2 className="flex items-center gap-x-2 text-3xl font-medium mb-5">
      <ActivityIcon size={24} strokeWidth={3} className="stroke-blue-500" />
      AI Usage Report
      <div
        className="px-2 py-1 text-sm gap-x-1 items-center text-neutral-600 bg-neutral-100
                   rounded-xl inline-flex dark:bg-neutral-800 dark:text-neutral-400"
      >
        <Globe size={16} />
        Service: {formatSource(source)}
      </div>
    </h2>
  );
}
